import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const categoryService = {
  getCategoryDetails: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/template/process/category`, getAxiosOptions(user)))
      .data
  },
  getAllCategories: async (user) => {
    return (
      await axios.get(`${NODE_BASE_URL}/template/process/category/all`, getAxiosOptions(user))
    ).data
  },
  createCategory: async (user, data) => {
    return (
      await axios.post(`${NODE_BASE_URL}/template/process/category`, data, getAxiosOptions(user))
    ).data
  },
}
